import { getItemFromPersistentStore } from './Persist';
import { defaultLocale } from '../constants';
import { DIRECTION_RTL, DIRECTION_LTR } from '../constants'
import { I18nManager } from 'react-native';
import { languageMapping } from '../../../common/locales';

export const getDocumentDirection = language => (language === 'ar' ? DIRECTION_RTL : DIRECTION_LTR);

export const getInterfaceLanguage = () => {
  let language;
  if (typeof navigator === 'undefined') {
    language = defaultLocale;
  }
  if (!!navigator && !!navigator.language) {
    language = navigator.language;
  } else if (!!navigator && !!navigator.languages && !!navigator.languages[0]) {
    language = navigator.languages[0];
  } else if (!!navigator && !!navigator.userLanguage) {
    language = navigator.userLanguage;
  } else if (!!navigator && !!navigator.browserLanguage) {
    language = navigator.browserLanguage;
  }
  language = language || defaultLocale;
  language = getItemFromPersistentStore('language', language);
  document.dir = getDocumentDirection(language);
  I18nManager.forceRTL(language === 'ar' ? true : false);
  document.documentElement.lang = language;
  if (languageMapping[language]) {
    return language;
  }
  const splittedValues = language.split('-');
  language = splittedValues[0];
  return languageMapping[language] ? language : defaultLocale;
  };
